import { Component, EventEmitter, Input, Output } from '@angular/core';
import Product from 'src/app/model/product/product';
import { ProductTypes } from 'src/app/model/product/product-type';
import { CLIENT_WINDOW_STICKER_TYPE } from 'src/app/model/product/windowsticker/client-windowsticker';
import { Project } from 'src/app/model/project/project';

@Component({
  selector: 'client-product-wrapper',
  templateUrl: './client-product-wrapper.component.html',
  styleUrls: ['./client-product-wrapper.component.scss']
})
export class ClientProductWrapperComponent {
  @Input()
  inputProject: Project;
  @Input()
  inputProduct: Product;
  @Input()
  oldSystemImmo: boolean = false;

  @Output()
  productInitialized = new EventEmitter<Product>();
  @Output()
  save = new EventEmitter<any>();

  PRODUCT_TYPES = ProductTypes;
  CLIENT_WINDOW_STICKER_TYPE = CLIENT_WINDOW_STICKER_TYPE;
}
